// extracted by mini-css-extract-plugin
export default {"app":"App_app__4JdJi","bounceAnim":"App_bounceAnim__Y3Byt","bounce":"App_bounce__H5Na+"};